<div class="main">
  <spb-header/>
  <router-outlet/>

  <div [style.flex]="1"></div>
  <spb-footer
    [license]="true"
    [version]="version"
    (logoutUser)="service.reset()"
    copyrightYears="2026"
  />
</div>